import { render, staticRenderFns } from "./security_access.vue?vue&type=template&id=a859145a&scoped=true"
import script from "./security_access.vue?vue&type=script&lang=js"
export * from "./security_access.vue?vue&type=script&lang=js"
import style0 from "./security_access.vue?vue&type=style&index=0&id=a859145a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a859145a",
  null
  
)

export default component.exports